import ActionType from 'store/_utils/classes/ActionType';

import type IActionType from 'store/_utils/interfaces/IActionType';

class OrderTypes {
  static list: IActionType = new ActionType('ORDER/LIST');
  static schedule: IActionType = new ActionType('ORDER/SCHEDULE');
  static items: IActionType = new ActionType('ORDER/ITEMS');
  static itemtrack: IActionType = new ActionType('ORDER/ITEM_TRACK');
  static batch: IActionType = new ActionType('ORDER/BATCH');
  static sent: IActionType = new ActionType('ORDER/SENT');
  static products: IActionType = new ActionType('ORDER/PRODUCTS');
  static status: IActionType = new ActionType('ORDER/STATUS');
  static export: IActionType = new ActionType('ORDER/EXPORT');
}

export default OrderTypes;
